import { required, integer } from 'vuelidate/lib/validators'
import { itemExists, validQuantity } from '@/plugins/vuelidate/validators'

export const validations = {
  orderItem: {
    item_code: {
      required,
      itemExists
    },
    quantity: {
      required,
      integer,
      validQuantity
    }
  }
}

export const messages = {
  orderItem: {
    item_code: {
      itemExists
    },
    quantity: {
      validQuantity
    }
  }
}